import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import { PageLayout } from "./components/page-layout.component";
import { appTheme } from "./config/theme/app.theme";
import { AppRoutes } from "./routes/app.routes";

export const App = () => (
  <ThemeProvider theme={appTheme}>
    <CssBaseline />
    <BrowserRouter>
      <PageLayout>
        <AppRoutes />
      </PageLayout>
    </BrowserRouter>
  </ThemeProvider>
);
